import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { POMEGRANATE, MOUNTAIN_MEADOW, MANGO_TANGO, IRON } from '../../utils/colors';

import ApplianceStatusNotification from '../ApplianceStatusNotification';

import '../CustomIcon/styles.css';
import './styles.css';

import okIcon from '../ReportOverviewCard/ok.svg';

class ReportLineChart extends Component {
  isOverQuota() {
    const { quota, currentQuota } = this.props;
    return currentQuota > quota;
  }

  isNotInclude() {
    const { quota } = this.props;
    return quota <= 0;
  }

  isOverQuotaOrNotInclude() {
    const { isActive } = this.props;

    return this.isOverQuota() || this.isNotInclude() || isActive === false;
  }

  getBackgroundColor(backgroundColor, isSecondary) {
    if (this.isOverQuotaOrNotInclude()) {
      if (this.isNotInclude() && !this.isOverQuota()) {
        return IRON;
      }
      return POMEGRANATE;
    } else if (isSecondary) {
      return MANGO_TANGO;
    } 
    return backgroundColor;
  }

  isQuotaUnlimited() {
    const { quota } = this.props;
    return quota >= 999999999;
  }

  isSwitchFeature() {
    const { isActive } = this.props;
    return isActive != null;
  }

  isNotQuotaUnlimitedAndIsNotSwitchFeature() {
    return !this.isQuotaUnlimited() && !this.isSwitchFeature();
  }

  isApplianceAndIsFeature() {
    const { isAppliance, isFeature } = this.props;

    return isAppliance && isFeature;
  }

  renderQuota() {
    const {
      quota,
      currentQuota,
      isOverview,
      quantityName,
      prefixedMonth,
      currentUsage,
      type
    } = this.props;

    let publicUsage;
    let privateUsage;
    const currentQuotaLen = currentQuota && String(currentQuota).length;
    const quotaLen = quota && String(quota).length;
    const isOverflow = isOverview && (currentQuotaLen + quotaLen >= 14);
    const currentQuotaValue = isNaN(currentQuota) ? 0 : currentQuota;
    const quotaValue = isNaN(quota) ? 0 : quota;

    if (currentUsage) {
      publicUsage = currentUsage.public;
      privateUsage = currentUsage.private;
    }

    return (
      <div className="report-line-chart-row">
        <div className="report-line-chart-quota">
          <strong>
            {currentQuotaValue.toLocaleString()}
          </strong>{' '}
          <small style={{ fontSize: isOverflow ? '12px' : '18px' }}>
            {this.isNotQuotaUnlimitedAndIsNotSwitchFeature() &&
            !this.isApplianceAndIsFeature() && (
              <span style={{ verticalAlign: 'bottom' }}>
                of {quotaValue.toLocaleString()}{' '}
              </span>
            )}
            {(this.isQuotaUnlimited() ||
            this.isSwitchFeature() ||
            !isOverview ||
            this.isApplianceAndIsFeature()) && type !== 'quotaEnterpriseConnections' ? (
              `${quantityName || 'Active Users'} ${prefixedMonth || ''}`
            ) : (
              ''
            )}
          </small>
          
        </div>
      </div>
    );
  }

  renderBar() {
    const {
      percentage,
      percentageDetails,
      backgroundColor
    } = this.props;

    if (
      this.isNotQuotaUnlimitedAndIsNotSwitchFeature() &&
      !this.isApplianceAndIsFeature()
    ) {
      return (
        <div className="report-line-chart-bar">
          {percentageDetails ? (
            <div>
              <div
                className="report-line-chart-fill"
                style={{
                  width: `${percentageDetails.appliance}%`,
                  backgroundColor: this.getBackgroundColor(backgroundColor)
                }}
              />
              <div
                className="report-line-chart-fill"
                style={{
                  width: `${percentageDetails.cloud}%`,
                  backgroundColor: this.getBackgroundColor(backgroundColor, true)
                }}
              />
            </div>
          ) : (
            <div
              className="report-line-chart-fill"
              style={{
                width: `${this.isOverQuotaOrNotInclude() ? 100 : percentage}%`,
                backgroundColor: this.getBackgroundColor(backgroundColor)
              }}
            />
          )}
        </div>
      );
    }

    return null;
  }

  renderDetails() {
    const { percentage, contactSales, contactSalesLink, isActive } = this.props;

    if (
      (this.isSwitchFeature() && isActive) ||
      this.isApplianceAndIsFeature()
    ) {
      return (
        <div className="report-overview-active" style={{ order: '0' }}>
          <img src={okIcon} alt="Active" /> <span>Active</span>
        </div>
      );
    } else if (this.isQuotaUnlimited()) {
      return (
        <div className="report-line-chart-percentage is-unlimited">
          Unlimited Quota
        </div>
      );
    } else if (this.isOverQuotaOrNotInclude()) {
      return (
        <div className="report-line-chart-overquota">
          <span className="custom-icon custom-icon-circle custom-icon-small custom-icon-warning">
            !
          </span>
          <span className="report-line-chart-overquota-message">
            {this.isNotInclude() || this.isSwitchFeature() ? (
              'This feature is not included in your subscription. '
            ) : (
              'This feature is over quota. '
            )}
            {contactSales && (
              <span>
                <a href="#" onClick={contactSales}>
                  {contactSalesLink || 'Talk to Sales'}
                </a>
              </span>
            )}
          </span>
        </div>
      );
    }

    return (
      <div className="report-line-chart-percentage">{`${percentage}%`}</div>
    );
  }

  renderCurrentQuotaDetails() {
    const {
      currentUsage,
      currentQuotaDetails,
      quantityName,
      applianceUsageRecords,
      applianceUsageDueDate,
      isModalShown,
      showModal,
      hideModal,
      isAppliance
    } = this.props;

    if (currentQuotaDetails || currentUsage) {
      let appliance;
      let cloud;

      if (currentQuotaDetails) {
        appliance = currentQuotaDetails.appliance;
        cloud = currentQuotaDetails.cloud;

      } else if (currentUsage) {
        appliance = currentUsage.private;
        cloud = currentUsage.public;
      }

      return (
        <div className="report-line-chart-current-quota-details">
          <div className="report-line-chart-current-quota-details-item">
            <div className="report-line-chart-current-quota-details-square report-line-chart-current-quota-details-square-appliance" />
            <span className="report-line-chart-current-quota-details-description">
              Private Cloud Consumption ({Number(
                appliance || 0
              ).toLocaleString()}{' '}
              {quantityName || 'Active Users'})
            </span>
          </div>
          <div className="report-line-chart-current-quota-details-item">
            <div className="report-line-chart-current-quota-details-square report-line-chart-current-quota-details-square-cloud" />
            <span className="report-line-chart-current-quota-details-description">
              Public Cloud Consumption ({Number(cloud || 0).toLocaleString()}{' '}
              {quantityName || 'Active Users'})
            </span>
          </div>
          {isAppliance && (
            <div style={{ marginLeft: 'auto', lineHeight: '1' }}>
              <ApplianceStatusNotification
                applianceUsageRecords={applianceUsageRecords}
                applianceUsageDueDate={applianceUsageDueDate}
                isModalShown={isModalShown}
                showModal={showModal}
                hideModal={hideModal}
                showInfoLink
              />
            </div>
          )}
        </div>
      );
    }

    return null;
  }

  render() {
    const { isOverview } = this.props;

    return (
      <div
        className={classNames('report-line-chart', {
          'is-overview': isOverview,
          'is-unlimited': this.isQuotaUnlimited()
        })}
      >
        {this.renderQuota()}
        {this.renderDetails()}
        {this.renderBar()}
        {this.renderCurrentQuotaDetails()}
      </div>
    );
  }
}

ReportLineChart.propTypes = {
  quota: PropTypes.number,
  currentQuota: PropTypes.number,
  currentQuotaDetails: PropTypes.object,
  currentUsage: PropTypes.object,
  percentage: PropTypes.number,
  percentageDetails: PropTypes.object,
  isOverview: PropTypes.bool,
  backgroundColor: PropTypes.string,
  contactSales: PropTypes.func,
  contactSalesLink: PropTypes.string,
  quantityName: PropTypes.string,
  type: PropTypes.string,
  isActive: PropTypes.bool,
  isAppliance: PropTypes.bool,
  isFeature: PropTypes.bool,
  applianceUsageRecords: PropTypes.array,
  applianceUsageDueDate: PropTypes.string,
  isModalShown: PropTypes.bool,
  showModal: PropTypes.func,
  hideModal: PropTypes.func,
  prefixedMonth: PropTypes.string
};

ReportLineChart.defaultProps = {
  percentage: 0,
  backgroundColor: MOUNTAIN_MEADOW,
  isOverview: false
};

export default ReportLineChart;
